import { ShiftDirectionEnum } from '../../../../common/enum/shift-direction.enum';
import { InternalServerErrorException } from '../../../../common/exceptions/exceptions';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import { shiftDateToNearestGranularity } from '../../../../common/utils/datetime.util';
import { GetChallengeInsightProgressSummaryRequestDto } from '../../../../interface/dtos/challenge-insights/get-challenge-insight-progress-summary.request.dto';
import { MetricValueType } from '../../../../interface/dtos/challenge-insights/metric-value-type';
import { ChallengeInsightProgressSelfReportSummaryAggregateRoot } from '../../../domain/aggregates/challenge-insights/challenge-insight-progress-self-report.aggregate-root';
import { GetChallengeInsightProgressSelfReportSummaryDomainService } from '../../../domain/services/challenge-insights/self-report/get-challenge-insight-progress-self-report-summary.domain-service';
import { OrgChallengeTargetResultPort } from '../../ports/challenge-target-result/org-challenge-target-result.port';

export class GetChallengeInsightProgressSelfReportSummaryApplicationService {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly port: OrgChallengeTargetResultPort,
    protected readonly domainService: GetChallengeInsightProgressSelfReportSummaryDomainService
  ) {}

  async execute(
    props: GetChallengeInsightProgressSummaryRequestDto
  ): Promise<ChallengeInsightProgressSelfReportSummaryAggregateRoot> {
    try {
      this.logManager.debug(
        'Called GetChallengeInsightProgressSelfReportSummaryApplicationService'
      );

      const shiftedEndDate = shiftDateToNearestGranularity({
        date: new Date(props.params.endDate),
        granularity: props.params.granularity,
        direction: ShiftDirectionEnum.Left,
      });
      const [entities, todayEntities] = await Promise.all([
        this.port.getAccountChallengeTargetResultsForDateRange({
          startDate: props.params.startDate,
          endDate: props.params.endDate,
          userIds: props.params.userIds,
          granularity: props.params.granularity,
          token: props.config.token,
          challengeTargetId: props.params.key ?? undefined,
          segments: props.params.segments ?? undefined,
          departmentId: props.params.departmentId ?? undefined,
        }),
        this.port.getAccountChallengeTargetResultsForDateRange({
          startDate: shiftedEndDate.toISOString().split('T')[0],
          endDate: props.params.endDate,
          userIds: props.params.userIds,
          granularity: props.params.granularity,
          token: props.config.token,
          challengeTargetId: props.params.key ?? undefined,
          departmentId: props.params.departmentId ?? undefined,
        }),
      ]);
      return await this.domainService.execute({
        entities,
        systemDayEntities: todayEntities,
        type: MetricValueType.Boolean,
        targetValue: props.params.challengeTargetValue,
      });
    } catch (error) {
      this.logManager.error(error);
      throw new InternalServerErrorException(error);
    }
  }
}
